import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import classes from "./HeaderController.module.scss";
import { ColorButtons } from "../../UIkit";
import WithIconButton from "../../UIkit/WithIconButton";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { useMediaQuery } from "@material-ui/core";
import {
  ORDER_CANCELLED,
  ORDER_CONFIRMED,
  ORDER_PLACED,
  ORDER_RECEIVED,
} from "../../../constants/orderStatus";
import { ConfirmStatuChangeModal } from "../../UIkit/modal/ConfirmStatusChangeModal";
import { updateMultiOrdersStatusToFireStore } from "../../../functions/orders";
import {
  getMailFormTargets,
  isBlockedOnMobile,
} from "../../../functions/order/statusTransition";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmCreatePdfModal } from "../../UIkit/modal/ConfirmCreatePdfModal";
import { createOrderForm } from "../../../functions/orderForm/createOrderForm";
import { MailForm } from "../../UIkit/modal/mailForm/MailForm";
import { exportOrdersToCsv } from "../../../functions/export";
import { useMobile } from "../../../hooks/useMobile";
import { getUserInfo } from "../../../reducks/users/selectors";
import ExportMenu from "../../UIkit/modal/ExportMenu";

const buttonSize = (isIphone) => {
  return isIphone ? 70 : 80;
};
const calcDisplayPrice = (filteredOrders) => {
  let price = 0;
  let totalPrice = 0;
  let count = 0;
  const selectedOrder = [];
  filteredOrders.forEach((order) => {
    if (order.isChecked) {
      price += parseInt(order.totalPrice);
      count++;
      selectedOrder.push(order);
    }
    totalPrice += parseInt(order.totalPrice);
  });
  return { price, totalPrice, count, selectedOrder };
};

const HeaderController = (props) => {
  const { filteredOrders } = props;
  const userInfo = useSelector(getUserInfo);
  const { isMobile } = useMobile();
  const dispatch = useDispatch();
  const { price, totalPrice, count, selectedOrder } = useMemo(() => {
    return calcDisplayPrice(filteredOrders);
  }, [filteredOrders]);
  const isIphone = useMediaQuery("(max-width:600px)");
  const [isShow, setIsShow] = useState(false);
  const [isShowErrorPDF, setIsShowErrorPDF] = useState(false);
  const [targetStatus, setTargetStatus] = useState(null);
  const [orderForms, setOrderForms] = useState([]);
  const [orderShops, setOrderShops] = useState([]);
  const [isShowMailForm, SetIsShowMailForm] = useState(false);
  const [isShowExport, setIsShowExport] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const handleStausButtonClick = (updatingStatus) => {
    if (!selectedOrder?.length) return;
    // メール送信を伴う発注はモバイル端末では受け付けない
    // （モバイルではメール送信フォームを表示できず、ステータスだけが
    //   発注済になってしまうのを防ぐ）。
    // 検収済から発注済へ戻すだけの操作はメール送信を伴わないので許可する。
    if (isBlockedOnMobile(updatingStatus, selectedOrder) && isMobile) {
      alert(
        "発注（メール送信）はモバイル端末では行えません。\nPCのブラウザから操作してください。"
      );
      return;
    }
    setIsShow(true);
    setTargetStatus(updatingStatus);
  };
  const updateStatus = async (status, orders, dateInput) => {
    // 確認ダイアログを閉じてから実行する
    onCancel();
    try {
      await dispatch(
        updateMultiOrdersStatusToFireStore(status, orders, userInfo, dateInput)
      );
    } catch (e) {
      // ステータス更新に失敗した場合はメール送信フォームを開かない
      alert(
        "ステータスの更新に失敗しました。通信環境を確認して再度お試しください。"
      );
      return;
    }
    // 注文済・取消済からの発注は仕入先へ注文書が必要。
    // 検収済からの戻しだけの場合は既に送付済みなのでフォームを開かない。
    // 前進と戻しが混在した場合は、注文書に載せるのも注文書が必要な分だけに絞る
    // (選択全件を渡すと、戻した注文の注文書まで仕入先へ再送されてしまう)。
    const mailTargets = getMailFormTargets(status, orders);
    if (mailTargets.length > 0 && !isMobile) {
      ReIssue(mailTargets);
    }
  };
  const onCancel = () => {
    setIsShow(false);
    setIsShowErrorPDF(false);
    setTargetStatus(null);
    setOrderForms([]);
    setOrderShops([]);
  };
  const handlePDFButtonClick = () => {
    if (!selectedOrder?.length) {
      return;
    }
    // ReIssue();
    setIsShowErrorPDF(true);
    setTargetStatus(ORDER_CONFIRMED);
  };
  const ReIssue = (targetOrders) => {
    //販売店情報とPDFファイルを取得
    let orderFormData;
    try {
      orderFormData = createOrderForm(targetOrders);
    } catch (e) {
      // 注文データの欠落等で注文書を組み立てられない場合は、
      // 無言で終わらせず明示する（メール送信フォームは開かない）
      console.error("注文書データ作成エラー:", e);
      alert(
        "注文書データの作成に失敗しました。選択した注文の内容をご確認ください。\n（ステータスは発注済に更新済みです。メールは「再発行」から送信できます）"
      );
      return;
    }
    setOrderForms(orderFormData.forms);
    setOrderShops(orderFormData.shops);
    //メール送信フォームのダイアログを開く
    SetIsShowMailForm(true);
  };
  useEffect(() => {}, [isShowMailForm, orderForms]);
  const handleExportCSV = () => {
    // exportOrdersToCsv(filteredOrders);
    if (!filteredOrders?.length) return;
    setIsShowExport(true);
  };
  const handleOutsideClick = useCallback(
    (event) => {
      if (
        isShowExport &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsShowExport(false);
      }
    },
    [isShowExport]
  );
  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [handleOutsideClick]);

  return (
    <div className={classes.root}>
      <div className={classes.result}>
        <span className={classes.info}>
          選択中 {`${count.toLocaleString()}件`}
        </span>
        <span
          className={classes.current}
        >{`\u00A5${price.toLocaleString()}`}</span>
        <span className={classes.percent}>/</span>
        <span
          className={classes.total}
        >{`\u00A5${totalPrice.toLocaleString()}`}</span>
      </div>
      <div className={classes.buttons}>
        <div className={classes.status}>
          <ColorButtons
            label={"注文"}
            color="placed"
            onClick={() => handleStausButtonClick(ORDER_PLACED)}
            width={buttonSize(isIphone)}
            height={32}
            bottom={0}
          />

          <ColorButtons
            label={"発注"}
            color="delete"
            onClick={() => handleStausButtonClick(ORDER_CONFIRMED)}
            width={buttonSize(isIphone)}
            height={32}
            bottom={0}
          />
          <ColorButtons
            label={"検収"}
            color="received"
            onClick={() => handleStausButtonClick(ORDER_RECEIVED)}
            width={buttonSize(isIphone)}
            height={32}
            bottom={0}
          />
          <ColorButtons
            label={"取消"}
            color="grey"
            onClick={() => handleStausButtonClick(ORDER_CANCELLED)}
            width={buttonSize(isIphone)}
            height={32}
            bottom={0}
          />
        </div>
        {!isMobile && (
          <div className={classes.others}>
            <WithIconButton
              label="再発行"
              fontSize={14}
              width={100}
              height={32}
              bottom={0}
              color="red"
              icon={<PictureAsPdfIcon />} // アイコンをpropsで渡す
              onClick={handlePDFButtonClick}
            />
            <div className={classes.export}>
              <WithIconButton
                label="CSV"
                fontSize={16}
                width={100}
                height={32}
                bottom={0}
                color="blue"
                icon={<SystemUpdateAltIcon />} // アイコンをpropsで渡す
                onClick={handleExportCSV}
              />
            </div>
          </div>
        )}
      </div>
      {isShow && targetStatus && (
        <ConfirmStatuChangeModal
          setIsShow={setIsShow}
          onExec={updateStatus}
          onCancel={onCancel}
          orders={selectedOrder}
          targetStatus={targetStatus}
          userInfo={userInfo}
        />
      )}
      {isShowExport && <ExportMenu ref={menuRef} orders={filteredOrders} />}
      {isShowErrorPDF && targetStatus && (
        <ConfirmCreatePdfModal
          setIsShow={setIsShowErrorPDF}
          onExec={ReIssue}
          onCancel={onCancel}
          orders={selectedOrder}
          targetStatus={targetStatus}
        />
      )}
      {isShowMailForm && orderForms && orderShops && (
        <MailForm
          setIsShow={SetIsShowMailForm}
          orders={orderForms}
          setOrders={setOrderForms}
          shops={orderShops}
          setShops={setOrderShops}
        />
      )}
    </div>
  );
};

export default HeaderController;
